<template>
  <customModal
    :containermd="true"
    :bodysm="true"
    @closeModal="closeActivityModal()"
  >
    <template #title>
      {{ $t("navigations.change llt name") }}
    </template>
    <template #body>
      <div class="form-group">
        <label>{{ $t("navigations.lltname") }}</label>
        <input
          type="text"
          class="form-control"
          v-model="meddraEditValue"
          @input="onInputChange"
          @keyup.enter="saveMeddraEdit"
          placeholder="Enter text here"
          autocomplete="off"
        />
        <div v-if="suggestions.length" class="suggestions-box">
          <div
            v-for="(item, index) in suggestions"
            :key="index"
            class="suggestion-item"
            @click="selectSuggestion(item)"
          >
          {{ item.value }}
            <!-- {{ item.key }}:  -->
          </div>
        </div>
      </div>

      This field will be verified when you click Save.
      <div class="modal-footer">
        <!-- <button type="button" class="cancel_btn btn-cor_rad py-1 px-4 mx-3">Cancel</button> -->
        <button type="button" class="save_btn py-1 px-4" @click="saveMeddraEdit()">
          Save
        </button>
      </div>
    </template>
  </customModal>
</template>
<script src="./meddraPopup.js"></script>
<style scoped>

.modal-footer {
   border-top: 0px ;
}
.suggestions-box {
  border: 1px solid #ccc;
  max-width: 300px;
  background: white;
  position: absolute;
  z-index: 1000;
  max-height: 280px; 
  overflow-y: auto;

}

.suggestion-item {
  padding: 5px;
  cursor: pointer;
}

.suggestion-item:hover {
  background: #eee;
}

</style>